import { Injectable } from '@angular/core';
import { select } from '@ngrx/store';
import { BaseStore } from '@client/lib/base-store';
import { Observable } from 'rxjs';
import { getAccessCodeDetailsIsActive } from '@client/selectors';

@Injectable()
export class AccessCodeDetailsStore extends BaseStore {
	get isActive(): Observable<boolean> {
		return this.store.pipe(select(getAccessCodeDetailsIsActive));
	}
}
